// extracted by mini-css-extract-plugin
export default {"footerBannerMovil":"FooterBanner_footerBannerMovil__neBAe","footerBannerDesktop":"FooterBanner_footerBannerDesktop__roHBc","img":"FooterBanner_img__DTv4b"};